<template>
    <div
        class="component experience-principles section"
        id="experience-principles-opener"
        data-shape-id="experiencePrinciples"
        data-logo-color-scheme="inverted"
    >
        <particles :particles="particles" />
        <div class="section-opener">
            <div class="wrapper wrapper-small">
                <div class="overline">Our Solution</div>
                <h2 class="major-heading">
                    Experience<br />
                    Principles
                </h2>
                <p>
                    Our Experience Principles are a springboard to develop branded customer experiences. They describe
                    the intended impact and tonality out of customer perspective at every touchpoint. They create a
                    group-wide shared mindset on experience.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import Particles from '../../Particles.vue';

    export default {
        name: 'ExperiencePrinciplesOpener',
        components: { Particles },
        data() {
            return {
                particles: [
                    {
                        shape: 'parallelogram',
                        color: 'magenta',
                        top: 15,
                        right: -1,
                        size: 'l',
                    },
                    {
                        shape: 'circle',
                        color: 'catskill-white',
                        top: 55,
                        left: 3,
                        size: 'l',
                    },
                ],
            };
        },
    };
</script>

<style scoped lang="scss">
    .section-opener {
        color: #ffffff;
    }
</style>
